import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { isAddressNotLimited } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { STOCK_TRANSFER_DOMESTIC } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import StockTransferDomesticFormModal from "@/components/stock/StockTransferDomesticFormModal.vue";
var defaultFormSearch = {
  allowedStatus: [STOCK_TRANSFER_DOMESTIC.STATUS.PENDING.id],
  reference: "",
  fromWarehouseIds: [],
  toWarehouseIds: []
};
var filtersStatus = Object.values(STOCK_TRANSFER_DOMESTIC.STATUS);
export default {
  name: "StockTransferDomesticListModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    StockTransferDomesticFormModal: StockTransferDomesticFormModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      dialog: false,
      editedId: null,
      gettingList: {
        formSearch: _objectSpread({}, defaultFormSearch),
        lastSearch: null,
        isPending: false,
        cancellationToken: null,
        filters: {
          fromWarehouses: [],
          toWarehouses: [],
          allowedStatus: filtersStatus
        },
        results: {
          headers: [{
            text: "Reference",
            value: "reference",
            align: "left"
          }, {
            text: "Status",
            value: "status",
            align: "center"
          }, {
            text: "From",
            value: "fromWarehouse",
            align: "left"
          }, {
            text: "To",
            value: "toWarehouse",
            align: "left"
          }, {
            text: "Products",
            value: "nbProductsConcerned",
            align: "center"
          }, {
            text: "",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap",
            sortable: false
          }],
          items: [],
          totalCount: null
        }
      },
      gettingWarehouses: {
        isPending: false,
        cancellationToken: null
      },
      STOCK_TRANSFER_DOMESTIC: STOCK_TRANSFER_DOMESTIC,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isLoading: function isLoading() {
      return false;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getWarehouses();
            _this2.search();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    search: function search() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$gettingList$can, _this3$gettingList$re, _this3$gettingList$re2;
        var _this, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingList.isPending = true;
              _this3.gettingList.results.items = [];
              _this3.gettingList.results.totalCount = 0;
              _this3.gettingList.lastSearch = _objectSpread({}, _this3.gettingList.formSearch);
              _this = _this3;
              (_this$gettingList$can = _this.gettingList.cancellationTokenSearch) === null || _this$gettingList$can === void 0 || _this$gettingList$can.cancel();
              _this.gettingList.cancellationTokenSearch = axios.CancelToken.source();
              paramsQuery = Object.encodeToUri(_this3.gettingList.formSearch);
              _context2.next = 10;
              return request("/v1/stock-transfer-domestics?params=".concat(paramsQuery), "get", null, true, "api", null, _this.gettingList.cancellationTokenSearch).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.gettingList.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load list.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context2.sent;
              _this3.gettingList.results.items = _toConsumableArray(response.data.value.items);
              _this3.gettingList.results.totalCount = (_this3$gettingList$re = +((_this3$gettingList$re2 = _this3.gettingList.results.items) === null || _this3$gettingList$re2 === void 0 ? void 0 : _this3$gettingList$re2.length)) !== null && _this3$gettingList$re !== void 0 ? _this3$gettingList$re : 0;
              _this3.gettingList.isPending = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    rowClick: function rowClick(item) {
      var _this4 = this;
      if (!item.isBusy) {
        this.editedId = item.id;
        this.$nextTick(function () {
          _this4.$refs.stockTransferDomesticForm.open();
        });
      }
    },
    getStatusClass: function getStatusClass(item) {
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.PENDING.id) return "fill-info";
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.DELIVERED.id) return "fill-success";
      if (item.status === STOCK_TRANSFER_DOMESTIC.STATUS.CANCELLED.id) return "fill-danger";
      return "fill-empty";
    },
    formClosed: function formClosed() {
      this.editedId = null;
    },
    getWarehouses: function getWarehouses() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$gettingWarehou;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.gettingWarehouses.isPending = true;
              (_this5$gettingWarehou = _this5.gettingWarehouses.cancellationToken) === null || _this5$gettingWarehou === void 0 || _this5$gettingWarehou.cancel();
              _this5.gettingWarehouses.cancellationToken = axios.CancelToken.source();
              data = {
                paging: null,
                allowDeleted: false
              };
              _this = _this5;
              _context3.next = 7;
              return request("/v1/warehouses", "post", data, true, "api", null, _this.gettingWarehouses.cancellationToken).catch(function (e) {
                _this.gettingWarehouses.isPending = false;
                _this.gettingWarehouses.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get warehouses", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 7:
              response = _context3.sent;
              _this5.gettingList.filters.warehouses = _toConsumableArray(response.data.warehouses.filter(function (x) {
                var _x$address, _x$address2;
                return x.id_warehouse != _this5.fromWarehouseId && isAddressNotLimited(_this5.loggedUserData, (_x$address = x.address) === null || _x$address === void 0 || (_x$address = _x$address.country) === null || _x$address === void 0 ? void 0 : _x$address.id_country, (_x$address2 = x.address) === null || _x$address2 === void 0 || (_x$address2 = _x$address2.state) === null || _x$address2 === void 0 ? void 0 : _x$address2.id_state);
              }));
              _this5.gettingWarehouses.isPending = false;
              _this5.gettingWarehouses.cancellationToken = null;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    open: function open() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.resetData();
              _this6.dialog = true;
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                _this6.resolve = resolve;
                _this6.reject = reject;
              }));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.gettingList.formSearch = _objectSpread({}, defaultFormSearch);
      this.gettingList.lastSearch = null;
    }
  }
};